<script setup lang="ts">
/**
 * 下部HTML。
 */

interface Props {
	/**
	 * 表示するHTML。
	 */
	html: string | null;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();
</script>

<template>
	<div class="revico-footer-part" v-html="html"></div>
</template>
